import { graphql } from "@/shared/gql";
import { EntityNotFoundError } from "@/shared/lib/errors/404-not-found-error";
import { useSuspenseQuery } from "@apollo/client";
import { getClient } from "@/shared/gql/apollo-client";

// The app shell (nav user, brand, company toggle, signup widget) reads AllMeProps on every
// page, through FetchMeQuery. That used to be a second round trip: AllMeProps asks for
// avatarUrl, locale and the full OwnCompanyProps, none of which OwnMeProps provides, so the
// cache-first read always missed. Selecting both here makes this query a superset, so
// FetchMeQuery is served from the cache instead of the network.
//
// Both fragments, not just AllMeProps: `slug` is a SwitchableCompany interface field that
// OwnMeProps selects unconditionally, while AllMeProps only reaches it through
// OwnCompanyProps (`on Company`), which would make it conditional for every route guard
// that looks a company up by slug.
export const FetchAuthenticatedUser = graphql(`
  query AuthUser {
    me {
      id
      ...OwnMeProps
      ...AllMeProps
    }
  }
`);

export const useFetchAuthenticatedUserQuery = () => {
  const result = useSuspenseQuery(FetchAuthenticatedUser);

  if (result.error) {
    throw result.error;
  }

  if (!result.data?.me) {
    throw new EntityNotFoundError("User");
  }

  return result.data.me;
};

export const fetchAuthenticatedUser = async () => {
  const result = await getClient().query({
    query: FetchAuthenticatedUser,
    fetchPolicy: "network-only",
  });

  if (!result) {
    throw new EntityNotFoundError("fetchAuthenticatedUser");
  }

  return result.data.me;
};
